<template>
  <div class="panel">
    <a class="back" @click="backPage">
      <i class="iconfont icon-icon_return" />返回
    </a>
    <div class="edit-panel">
      <div class="title">
        <span v-if="state === 'created'">{{ "新增应用" }}</span>
        <span v-if="state === 'edit'">{{ "编辑应用" }}</span>
        <span v-if="state === 'preview'">{{ "查看应用" }}</span>
      </div>
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        label-width="120px"
        class="form-box"
        label-position="left"
      >
        <div class="title-col">基本配置</div>
        <el-form-item
          label="发布渠道:"
          prop="name"
          :required="true"
          :show-message="false"
        >
          <el-checkbox-group v-model="formData.vasChannelList">
            <el-checkbox :label="1">云后台</el-checkbox>
            <el-checkbox :label="2">我的店铺</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          label="应用标题:"
          prop="name"
          :required="true"
          :show-message="false"
        >
          <el-input
            style="width: 280px"
            placeholder="请输入应用标题"
            maxlength="12"
            v-model="formData.name"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="应用标题备注:"
          prop="remark"
          :required="true"
          :show-message="false"
        >
          <el-input
            style="width: 280px"
            placeholder="请输入应用标题备注"
            maxlength="12"
            v-model="formData.remark"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="图标:"
          prop="iconUrl"
          :required="true"
          :show-message="false"
        >
          <Upload
            :file-list-new="fileListIcon"
            :type="iconType"
            :limit="1"
            @changeFile="getFileListIcon"
          />
          <p class="tips">尺寸:144x144像素,格式:jpg/png,小于10M</p>
        </el-form-item>
        <el-form-item
          label="卡片图:"
          prop="bgImgUrl"
          :required="true"
          :show-message="false"
        >
          <Upload
            :file-list-new="fileListIconbgImgUrl"
            :type="iconType"
            :limit="1"
            @changeFile="getFileListBgImgUrl"
          />
          <p class="tips">
            尺寸:335x385像素,格式:jpg/png,小于10M
            <el-popover :width="739" trigger="hover">
              <template #reference>
                <span class="tips-look-location">示例位置</span>
              </template>
              <img src="../../assets/bgUrl.png" alt="" style="width: 739px" />
            </el-popover>
          </p>
        </el-form-item>
        <el-form-item
          prop="theme"
          :required="true"
          :show-message="false"
          class="form-itemTheme"
        >
          <template v-slot:label
            >卡片文字
            <el-popover :width="200" trigger="hover">
              <template #reference>
                <img src="@/assets/icon_doubt.png" alt="" style="width: 20px" />
              </template>
              用于配置卡片内的文字颜色，例: 若卡片图背景为白底，请选择黑色系 </el-popover
            >:</template
          >
          <el-radio v-model="formData.theme" :label="0" @change="changeTheme"
            >黑色系</el-radio
          >
          <el-radio v-model="formData.theme" :label="1" @change="changeTheme"
            >白色系</el-radio
          >
        </el-form-item>
        <el-form-item
          label="展示权重:"
          prop="orderIndex"
          :required="true"
          :show-message="false"
        >
          <el-input
            type="number"
            style="width: 280px"
            placeholder="请输入1~100"
            v-model="formData.orderIndex"
          >
          </el-input>
          <p class="tips">数值越大权重越高，排序越靠前哦～</p>
        </el-form-item>
        <el-form-item
          label="应用介绍:"
          prop="summaryContent"
          :required="true"
          :show-message="false"
        >
          <el-input
            type="textarea"
            resize="none"
            style="width: 280px"
            placeholder="请输入应用介绍"
            v-model="formData.summaryContent"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="所属分类:"
          prop="vasTypeList"
          :required="true"
          :show-message="false"
        >
          <el-checkbox-group v-model="formData.vasTypeList">
            <el-checkbox-button
              v-for="item in vasTypeOptions"
              :label="item.vasType"
              :key="item.vasType"
            >
              {{ item.vasTypeName }}</el-checkbox-button
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          label="价格单位:"
          prop="priceUnit"
          :required="true"
          :show-message="false"
        >
          <el-input
            style="width: 280px"
            placeholder="请输入价格单位"
            v-model="formData.priceUnit"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="版本选项:"
          prop="isDefault"
          :required="true"
          :show-message="false"
        >
          <el-button type="text" class="select-text" @click="selectVersion"
            >选择版本</el-button
          >
          <div v-for="(item, index) in selectedVersionData" :key="index">
            <el-radio
              v-model="currentIndex"
              :label="index"
              @change="changIsDefaultVersion(item.version, index)"
            >
              设为默认
            </el-radio>
            <span class="tab-card">
              {{ item.alias }}
              <i class="el-icon-close" @click="delselectedVersion(index)" />
            </span>
          </div>
        </el-form-item>
        <el-form-item
          label="产品类型:"
          prop="successedType"
          :required="true"
          :show-message="false"
        >
          <div>
            <el-radio
              v-model="formData.successedType"
              :label="0"
              @change="successedTypeFn"
              >非短信产品</el-radio
            >
            <el-radio
              v-model="formData.successedType"
              :label="1"
              @change="successedTypeFn"
              >短信产品(固定文案)</el-radio
            >
          </div>
        </el-form-item>
        <el-form-item
          v-if="formData.successedType === 0"
          label="开通/试用弹窗图片:"
          prop="successImgUrl"
          :show-message="false"
        >
          <Upload
            :file-list-new="successImgUrlList"
            :type="iconType"
            :limit="1"
            @changeFile="getSuccessImgUrlList"
          />
          <p class="tips">尺寸:550x320px像素,格式:jpg/png,小于10M</p>
        </el-form-item>
        <el-form-item
          label="详情页去使用:"
          :required="true"
          :show-message="false"
          label-width="124px"
        >
          <div class="flex">
            <el-input
              style="width: 280px"
              resize="none"
              placeholder="http"
              v-model="formData.successDetailUrl"
            >
            </el-input>
            <el-popover :width="700" trigger="hover">
              <template #reference>
                <span class="look-location">查看位置</span>
              </template>
              <img src="../../assets/pic_channelSuccess.png" alt="" />
            </el-popover>
          </div>
        </el-form-item>

        <!-- <el-form-item label="概览文案跳转:">
          <el-button type="text" class="select-text" @click="addFn">添加</el-button>
          <el-popover
            :width="620"
            trigger="hover">
            <template #reference>
              <span class="look-location">查看位置</span>
            </template>
            <img src="../../assets/overview.png" alt="">
          </el-popover>
            <div class="col"  v-for="(item, index) in formData.summaryLinkList" :key="index">
                <el-input
                style="width: 120px;margin-right: 4px;"
                resize="none"
                placeholder="请输入"
                v-model="item.text"
              >
              </el-input>
              <el-input
                style="width: 158px"
                resize="none"
                placeholder="http"
                v-model="item.url"
              >
              </el-input>
              <el-button type="text" class="look-location" @click="delFn(index)">删除</el-button>
            </div>
        </el-form-item> -->
        <el-form-item
          label="客服ChannelID:"
          :required="true"
          :show-message="false"
          label-width="124px"
        >
          <div class="flex">
            <el-select v-model="formData.onlineServiceChannelId" filterable>
              <el-option
                v-for="item in channelIDList"
                :key="item.value"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
            <el-popover :width="700" trigger="hover">
              <template #reference>
                <span class="look-location">查看位置</span>
              </template>
              <img src="../../assets/pic_channel.png" alt="" />
            </el-popover>
          </div>
        </el-form-item>
        <el-form-item
          v-if="formData.onlineServiceChannelId"
          label="咨询时间:"
          :required="false"
          :show-message="false"
          label-width="124px"
        >
          <div class="flex">
            <el-input
              style="width: 280px"
              resize="none"
              placeholder="请输入文本"
              v-model="formData.contactServiceTime"
            >
            </el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="开通/试用成功跳转:"
          :required="true"
          :show-message="false"
        >
          <div>
            <el-radio-group
              v-model="formData.openOnlineServiceAfterPaid"
              @change="selectHttpOrOnlineService"
            >
              <el-radio :label="false">网址</el-radio>
              <el-radio :label="true">在线客服</el-radio>
            </el-radio-group>
          </div>
          <div class="flex">
            <el-input
              style="width: 280px"
              resize="none"
              placeholder="http"
              v-if="!formData.openOnlineServiceAfterPaid"
              v-model="formData.successGotoUrl"
            >
            </el-input>
            <el-popover
              :width="700"
              trigger="hover"
              v-if="!formData.openOnlineServiceAfterPaid"
            >
              <template #reference>
                <span class="look-location">查看位置</span>
              </template>
              <img src="../../assets/pic_trialsus.png" alt="" />
            </el-popover>
          </div>
        </el-form-item>
        <el-form-item
          label="立即使用:"
          :required="false"
          :show-message="false"
          label-width="124px"
        >
          <div class="flex">
            <el-input
              style="width: 280px"
              resize="none"
              placeholder="请输入文本"
              v-model="formData.vasIntroUrl"
            >
            </el-input>
          </div>
        </el-form-item>
        <div class="title-col">试用配置</div>
        <el-form-item
          label="是否试用:"
          prop="hasFreeOption"
          :required="true"
          :show-message="false"
        >
          <el-radio
            v-model="formData.hasFreeOption"
            :label="true"
            @change="changeIsFree"
            >是</el-radio
          >
          <el-radio
            v-model="formData.hasFreeOption"
            :label="false"
            @change="changeIsFree"
            >否</el-radio
          >
        </el-form-item>
        <el-form-item
          label="试用开通内容:"
          v-if="formData.hasFreeOption == true"
          prop="freeContent"
          :required="true"
          :show-message="false"
        >
          <div class="flex">
            <el-input
              style="width: 280px"
              placeholder="请输入"
              v-model="formData.freeContent"
            >
            </el-input>
            <el-popover :width="340" trigger="hover">
              <template #reference>
                <span class="look-location">查看位置</span>
              </template>
              <img src="../../assets/pic_trial.png" alt="" />
            </el-popover>
          </div>
        </el-form-item>
        <el-form-item
          label="试用内容:"
          v-if="formData.hasFreeOption == true"
          :required="true"
        >
          <div
            v-if="formData.freeConfigList && formData.freeConfigList.length > 0"
          >
            <div v-for="(item, index) in formData.freeConfigList" :key="index">
              <span style="color: #303849; margin-right: 53px">{{
                item.name
              }}</span>
              <el-input
                placeholder="请输入"
                v-model="item.count"
                class="try-input"
              >
                <template #append>{{ item.unit }}</template>
              </el-input>
            </div>
          </div>
          <span style="color: #9ca0a8" v-else>请先选择默认版本选项</span>
        </el-form-item>
        <div v-if="formData.vasChannelList.indexOf(1) !== -1">
          <div class="title-col">云端配置</div>
          <!-- <el-form-item label="价格表:" :required="true">
            <el-switch
              v-model="formData.priceEnable"
              active-color="#255AFF"
              inactive-color="#B9BCC1"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="视频背景框:">
            <Upload
              :file-list-new="fileListBg"
              :limit="1"
              @changeFile="getFileListBg"
            />
            <p class="tips">
              尺寸:896x500，视频区域需预留628x353，需居中。格式:png,小于10M
            </p>
          </el-form-item>
          <el-form-item label="视频:">
            <Video
              :file-list-new="fileListVideo"
              :limit="1"
              @changeFile="getFileListVideo"
            />
            <p class="tips">格式:avi、mp4、mov、rmvb、m4v，小于500M</p>
          </el-form-item>
          <el-form-item
            label="详情图:"
            prop="imgUrlList"
            :required="true"
            :show-message="false"
          >
            <Upload
              :file-list-new="fileListDetail"
              :limit="10"
              :type="picType"
              @changeFile="getFileListDetail"
            />
            <p class="tips">
              尺寸:896x500，视频区域需预留628x353，需居中。格式:png,小于10M
            </p>
          </el-form-item>
          <el-form-item
            label="详情图高度:"
            prop="vasDetailHeight"
            :required="false"
            :show-message="false"
          >
            <el-input
              style="width: 280px"
              v-model="formData.vasDetailHeight"
              placeholder="请输入"
            ></el-input>
          </el-form-item> -->
          <el-form-item
            label="详情页链接:"
            prop="detailUrl"
            :required="true"
            :show-message="false"
          >
            <el-input
              style="width: 280px"
              v-model="formData.detailUrl"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="formData.vasChannelList.indexOf(2) !== -1">
          <div class="title-col">我的店铺配置</div>
          <el-form-item label="图标:" :required="true">
            <Upload
              :file-list-new="storeIconUrlList"
              :limit="1"
              @changeFile="getStoreIconUrlList"
            />
            <p class="tips">尺寸:260x240像素,格式:jpg/png,小于10M</p>
          </el-form-item>
          <el-form-item label="视频背景框:">
            <Upload
              :file-list-new="fileListBg2"
              :limit="1"
              @changeFile="getFileListBg2"
            />
            <p class="tips">格式:png,小于10M</p>
          </el-form-item>
          <el-form-item label="视频:">
            <Video
              :file-list-new="fileListVideo2"
              :limit="1"
              @changeFile="getFileListVideo2"
            />
            <p class="tips">格式:avi、mp4、mov、rmvb、m4v，小于500M</p>
          </el-form-item>
          <el-form-item
            label="详情图:"
            prop="imgUrlList"
            :required="true"
            :show-message="false"
          >
            <Upload
              :file-list-new="fileListDetail2"
              :limit="10"
              :type="picType"
              @changeFile="getFileListDetail2"
            />
            <p class="tips">格式:jpg/png每张图片大小不超过10M,不超过10张</p>
          </el-form-item>
        </div>
        <div class="title-col">其他配置</div>
        <el-form-item
          label="是否展示给代理商客户:"
          label-width="100px"
          class="label-height"
          prop="forAgentUser"
          :show-message="false"
          :required="true"
        >
          <el-radio v-model="formData.forAgentUser" :label="true">是</el-radio>
          <el-radio v-model="formData.forAgentUser" :label="false">否</el-radio>
        </el-form-item>
        <el-form-item label="适用行业:">
          <el-select
            v-model="formData.industryList"
            multiple
            placeholder="请选择"
            style="width: 280px"
            @change="changeIndustry"
          >
            <el-option label="全部" value="0"></el-option>
            <el-option
              v-for="item in industryListOptions"
              :key="item.number"
              :label="item.name"
              :disabled="item.disabled"
              :value="item.number"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="角标:">
          <el-radio-group v-model="vasLabelId" @change="changeVasLabel">
            <el-radio :label="null">无</el-radio>
            <el-radio
              :label="item.labelId"
              v-for="(item, index) in vasLabelOptions"
              :key="index"
            >
              {{ item.labelName }}
              <el-date-picker
                v-if="currentId === index + 1"
                v-model="dateRange"
                type="daterange"
                @change="changeDateRange"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="用户评价" :required="true">
          <el-table :data="formData.vasCommentList" class="userContentTable">
            <el-table-column label="评价内容" width="320px">
              <template v-slot="scope">
                <el-input
                  v-model="scope.row.content"
                  placeholder="请输入"
                  class="contentInput"
                />
              </template>
            </el-table-column>
            <el-table-column label="门店名称" width="220px">
              <template v-slot="scope">
                <el-input
                  v-model="scope.row.storeName"
                  placeholder="请输入"
                  class="storeNameInput"
                />
              </template>
            </el-table-column>
            <el-table-column label="门店地址" width="220px">
              <template v-slot="scope">
                <el-input
                  v-model="scope.row.storeAddress"
                  placeholder="请输入"
                  class="storeAddressInput"
                />
              </template>
            </el-table-column>
            <el-table-column>
              <template v-slot="scope">
                <div
                  class="deleteUserContent el-icon-remove"
                  @click="deleteUserContent(scope.$index)"
                ></div>
              </template>
            </el-table-column>
            <template v-slot:append>
              <el-button type="text" @click="addUserContent" style="width: 100%"
                >+ 新增</el-button
              >
            </template>
          </el-table>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer" v-if="state === 'created'">
      <div>
        <el-button
          class="footer__button"
          type="primary"
          size="small"
          @click="submit('0')"
          >发布</el-button
        >
      </div>
    </div>
    <div class="footer" v-if="state === 'edit'">
      <div>
        <el-button type="primary" size="small" @click="submit('0')"
          >发布</el-button
        >
        <el-button type="primary" size="small" @click="submit('save')"
          >保存</el-button
        >
        <el-button type="primary" size="small" @click="submit('copy')"
          >复制</el-button
        >
        <el-button
          class="footer__button"
          size="small"
          type="danger"
          @click="submit('-1')"
          >删除应用</el-button
        >
      </div>
    </div>

    <el-dialog
      title="选择版本（若未设置将自动默认展示原名称）"
      width="907px"
      v-model="dialogVisible"
      :before-close="handleClose"
    >
      <div>
        已选择:
        <span v-for="(item, index) in selectedVersionData" :key="index">
          <span class="tab-card" v-if="item.alias">
            {{ item.alias }}
            <i class="el-icon-close" @click="delselectedVersion(index)" />
          </span>
        </span>
        <el-input
          v-model="keyword"
          placeholder="服务名称、version"
          @keyup.enter="handleFilter"
          style="width: 280px"
        >
          <template #suffix>
            <i class="el-icon-search el-input__icon" @click="handleFilter"> </i>
          </template>
        </el-input>
      </div>
      <div class="box-table">
        <div class="list">
          <el-checkbox-group v-model="checkList" @change="changeCheckbox">
            <div
              v-for="item in compeleteList(productListOptions, 18, ' ')"
              :key="item.id"
            >
              <el-checkbox
                v-if="item.description"
                :value="item.version"
                :label="`${item.alias ? item.alias : item.description}:${
                  item.version
                }`"
              >
                <span class="name">
                  <span>{{ item.description ? item.description : "-" }}</span>
                  <br />
                  <span>{{ !item.alias ? "(未命名)" : item.alias }}</span>
                </span>
                <span class="version">{{ item.version }}</span>
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </div>
      <el-pagination
        class="pagination"
        @current-change="getProductList"
        :page-size="versionPageSize"
        :total="versionTotal"
        layout="total, ->, prev,pager, next"
      >
      </el-pagination>
      <template #footer>
        <span class="dialog-footer">
          <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
          <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
// import _ from 'lodash'
import dayjs from 'dayjs'
import Upload from '@/components/upload/index'
import Video from '@/components/upload/video'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { getDay } from '@/utils/utils'
import {
  saveApplication,
  changeApplyhub,
  getIndustryList,
  getVasType,
  getVasLabel,
  getProductList,
  getProductTypeList,
  getInfoDetails,
  getCustomerChannelList
} from '../../API/application'
// import { deleteTemplate } from '../../API/template'
dayjs.extend(customParseFormat)
export default {
  components: {
    Upload,
    Video
  },
  data () {
    const id =
      this.$route && this.$route.params.id === 'null'
        ? null
        : this.$route.params.id
    const state = this.$route.params.state
    return {
      id,
      state,
      uid: '',
      saveTemplateId: '',
      versionPageSize: 18,
      versionTotal: 1,
      keyword: null,
      productListOptions: [],
      checkList: [],
      currentIndex: 0,
      dateRange: '',
      formData: {
        priceEnable: true,
        hasFreeOption: true,
        theme: 0,
        vasChannelList: [],
        freeConfigList: [],
        forAgentUser: true,
        freeContent: '',
        iconUrl: '',
        imgUrlList: [],
        versionList: [],
        name: '',
        priceUnit: '',
        remark: '',
        successContent: '',
        successGotoUrl: '',
        successDetailUrl: '',
        successedType: 0,
        summaryContent: '',
        summaryLinkList: null,
        // summaryLinkList: [
        //   {
        //     text: '',
        //     url: ''
        //   }
        // ],
        vasTypeList: [],
        vasLabel: null,
        enable: 1,
        vasDetailHeight: null,
        detailUrl: '',
        openOnlineServiceAfterPaid: false,
        onlineServiceChannelId: null,
        afterPaidChannelId: null,
        // 初始化展示五条
        vasCommentList: [
          {
            content: null,
            storeName: null,
            storeAddress: null
          },
          {
            content: null,
            storeName: null,
            storeAddress: null
          },
          {
            content: null,
            storeName: null,
            storeAddress: null
          },
          {
            content: null,
            storeName: null,
            storeAddress: null
          },
          {
            content: null,
            storeName: null,
            storeAddress: null
          }
        ]
      },
      industryListOptions: [],
      fileListIcon: [],
      successImgUrlList: [],
      fileListIconbgImgUrl: [],
      showBgImgUrlLocation: false,
      iconType: 'icon',
      fileListVideo: [],
      fileListVideo2: [],
      fileListBg: [],
      fileListBg2: [],
      storeIconUrlList: [],
      picType: 'detailPic',
      fileListDetail: [],
      fileListDetail2: [],
      rules: {},
      texts: ['到期时间', '剩余数量', '应用服务'],
      addText: '',
      dialogVisible: false,
      selectedVersionData: [],
      vasTypeOptions: [],
      vasLabelOptions: [],
      vasLabelId: null,
      currentId: null
    }
  },
  async mounted () {
    this.getIndustryList()
    this.getVasType()
    this.getVasLabel()
    this.getProductList(1)
    this.getChannelIDList()
    if (this.state !== 'created') {
      this.getInfoDetails()
    }
  },
  computed: {},
  watch: {
    dialogVisible: {
      handler (newData, oldData) {
        if (!newData) {
          // 默认选项版本第一个，试用内容的调用
          this._version =
            this.selectedVersionData && this.selectedVersionData.length > 0
              ? this.selectedVersionData[0].version
              : null
          if (this.formData.hasFreeOption === true && this._version) {
            this.getProductTypeList()
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    compeleteList (arr, n, str) {
      for (let i = arr.length; i < n; i++) {
        arr.push(str)
      }
      return arr
    },
    changeDateRange (e) {
      this.formData.vasLabel.startTime = e[0]
      this.formData.vasLabel.endTime = e[1]
    },
    changeVasLabel (e) {
      const index = this.vasLabelOptions.findIndex(item => e === item.labelId)
      if (index !== -1) {
        const item = this.vasLabelOptions[index]
        this.formData.vasLabel = item
      } else {
        this.formData.vasLabel = null
      }
      this.currentId = index + 1
    },
    changeIndustry () {
      if (this.formData.industryList.indexOf('0') === -1) {
        this.industryListOptions.map(res => {
          res.disabled = false
        })
      } else {
        this.industryListOptions.map(res => {
          res.disabled = true
        })
        this.formData.industryList = ['0']
      }
    },
    changeCheckbox (val) {
      const versions = []
      if (this.selectedVersionData.length > 20) {
        this.message.error('最多只能一次选择20项')
        return
      }
      val.forEach(item => {
        const alias = item.split(':')[0]
        const version = item.split(':')[1]
        versions.push({
          alias: alias,
          version: version,
          isDefault: false
        })
      })
      this.selectedVersionData = [...this.formData.versionList, ...versions]
    },
    changIsDefaultVersion (val, index) {
      this.currentIndex = index
      this.selectedVersionData.map(e => {
        e.isDefault = false
      })
      this.selectedVersionData[index].isDefault = true
      this._version = val // 默认版本号
      if (this.formData.hasFreeOption === true && this._version) {
        this.getProductTypeList()
      }
    },
    confirm () {
      this.dialogVisible = false
      // 默认第一个为版本选项
      this.selectedVersionData[this.currentIndex].isDefault = true
    },
    handleClose () {
      this.dialogVisible = false
      this.selectedVersionData[this.currentIndex].isDefault = true
    },
    handleFilter () {
      this.getProductList(1)
    },
    delselectedVersion (index) {
      if (index === this.currentIndex) {
        this.currentIndex = 0
      }
      this.checkList.splice(index, 1)
      this.selectedVersionData.splice(index, 1)
    },
    selectVersion () {
      this.dialogVisible = true
    },
    changeIsFree (val) {
      if (val === true && this._version) {
        this.getProductTypeList()
      }
      if (val === false) {
        this.formData.freeConfigList = []
        this.formData.freeContent = null
      }
    },
    async getProductTypeList () {
      const res = await getProductTypeList({ version: this._version })
      const _freeConfigList = res
      _freeConfigList.map(e => {
        e.productType = e.type
        e.count = null
      })
      this.formData.freeConfigList = [..._freeConfigList]
    },
    // addFn () {
    //   if (this.formData.summaryLinkList === null) {
    //     this.formData.summaryLinkList = []
    //   }
    //   if (this.formData.summaryLinkList.length === 5) {
    //     this.$message({
    //       type: 'error',
    //       message: '最多不超过5个 '
    //     })
    //     return
    //   }
    //   const obj = {
    //     text: '',
    //     url: ''
    //   }
    //   this.formData.summaryLinkList.push(obj)
    // },
    // delFn (index) {
    //   this.formData.summaryLinkList.splice(index, 1)
    // },
    // 图标
    getFileListIcon (data, fileIds) {
      this.fileListIcon = data
      // this.fileListIdIcon = fileIds
      this.formData.iconUrl = data[0] ? data[0].url : ''
    },
    getSuccessImgUrlList (data, fileIds) {
      this.successImgUrlList = data
      // this.fileListIdIcon = fileIds
      this.formData.successImgUrl = data[0] ? data[0].url : ''
    },
    getFileListBgImgUrl (data, fileIds) {
      this.fileListIconbgImgUrl = data
      // this.fileListIdIcon = fileIds
      this.formData.bgImgUrl = data[0] ? data[0].url : ''
    },
    getFileListBg (data, fileIds) {
      this.fileListBg = data
      // this.fileListIdBg = fileIds
      this.formData.videoImgUrl = data[0] ? data[0].url : ''
    },
    getFileListBg2 (data, fileIds) {
      this.fileListBg2 = data
      // this.fileListIdBg = fileIds
      this.formData.storeVideoImgUrl = data[0] ? data[0].url : ''
    },
    getStoreIconUrlList (data, fileIds) {
      this.storeIconUrlList = data
      // this.fileListIdBg = fileIds
      this.formData.storeIconUrl = data[0] ? data[0].url : ''
    },
    // 视频
    getFileListVideo (data, fileIds) {
      this.fileListVideo = data
      // this.fileIdVideo = fileIds
      this.formData.videoUrl = data[0] ? data[0].url : ''
    },
    getFileListVideo2 (data, fileIds) {
      this.fileListVideo2 = data
      // this.fileIdVideo = fileIds
      this.formData.storeVideoUrl = data[0] ? data[0].url : ''
    },
    // 详情图-云平台
    getFileListDetail (data, fileIds) {
      const arrImgs = []
      this.fileListDetail = data
      // this.fileListIdDetail = fileIds
      this.fileListDetail.map(e => {
        if (e.url) {
          arrImgs.push(e.url)
        }
      })
      this.formData.imgUrlList = arrImgs
    },
    // 详情图-应用
    getFileListDetail2 (data, fileIds) {
      const arrImgs = []
      this.fileListDetail2 = data
      // this.fileListIdDetail = fileIds
      this.fileListDetail2.map(e => {
        if (e.url) {
          arrImgs.push(e.url)
        }
      })
      this.formData.storeImgUrlList = arrImgs
    },
    async getIndustryList () {
      const res = await getIndustryList({})
      if (res) {
        this.industryListOptions = [...res]
      }
    },
    async getVasLabel () {
      const res = await getVasLabel({})
      if (res) {
        this.vasLabelOptions = res
      }
    },
    async getVasType () {
      const res = await getVasType({})
      if (res) {
        const results = res.map(v => {
          return { vasType: v.type, vasTypeName: v.name }
        })
        this.vasTypeOptions = results
      }
    },
    // 选择版本
    async getProductList (versionPageNumber) {
      this.versionPageNumber = versionPageNumber
      var data = {
        pageNum: versionPageNumber,
        pageSize: this.versionPageSize,
        keyword: this.keyword
      }
      const res = await getProductList(data)
      this.versionTotal = res.total
      if (res) {
        this.productListOptions = res.list
      }
    },
    addTextFn (name) {
      this.addText = `${this.formData.successContent}` + '{' + `${name}` + '}'
      console.log('this.addText', this.addText)
      this.formData.successContent = this.addText
    },
    successedTypeFn (val) {
      if (val === 1) {
        this.formData.successContent = ''
      }
    },
    showNameClose () {
      this.showNameLoading = true
    },
    async getInfoDetails () {
      const res = await getInfoDetails({ uid: this.id })
      if (res) {
        const formData = res
        if (res.industryList === null) {
          formData.industryList = ['0']
        }
        if (res.iconUrl) {
          this.fileListIcon = [
            {
              uid: getDay('milliseconds'),
              url: res.iconUrl
            }
          ]
        }
        if (res.bgImgUrl) {
          this.fileListIconbgImgUrl = [
            {
              uid: getDay('milliseconds'),
              url: res.bgImgUrl
            }
          ]
        }
        if (res.successImgUrl) {
          this.successImgUrlList = [
            {
              uid: getDay('milliseconds'),
              url: res.successImgUrl
            }
          ]
        }
        if (res.videoImgUrl) {
          this.fileListBg = [
            {
              uid: getDay('milliseconds'),
              url: res.videoImgUrl
            }
          ]
        }
        if (res.storeVideoImgUrl) {
          this.fileListBg2 = [
            {
              uid: getDay('milliseconds'),
              url: res.storeVideoImgUrl
            }
          ]
        }
        if (res.storeIconUrl) {
          this.storeIconUrlList = [
            {
              uid: getDay('milliseconds'),
              url: res.storeIconUrl
            }
          ]
        }
        if (res.imgUrlList.length > 0) {
          const imgUrlList = res.imgUrlList
          const imgs = []
          imgUrlList.map(e => {
            //  uid: getDay('milliseconds'),
            imgs.push({
              uid: getDay('milliseconds'),
              url: e
            })
          })
          this.fileListDetail = imgs
        }
        if (res.storeImgUrlList.length > 0) {
          const imgUrlList = res.storeImgUrlList
          const imgs = []
          imgUrlList.map(e => {
            //  uid: getDay('milliseconds'),
            imgs.push({
              uid: getDay('milliseconds'),
              url: e
            })
          })
          this.fileListDetail2 = imgs
        }
        if (res.videoUrl) {
          this.fileListVideo = [
            {
              uid: getDay('milliseconds'),
              url: res.videoUrl
            }
          ]
        }
        if (res.storeVideoUrl) {
          this.fileListVideo2 = [
            {
              uid: getDay('milliseconds'),
              url: res.storeVideoUrl
            }
          ]
        }

        // 版本选项
        formData.versionList.map(v => {
          v.alias = v.name
        })
        this.selectedVersionData = formData.versionList
        // 获取getProductTypeList
        // if (this.selectedVersionData && this.selectedVersionData.length > 0) {
        //   const index = this.selectedVersionData.findIndex(e => e.isDefault === true)
        //   if (index !== -1 && formData.hasFreeOption) {
        //     this._version = this.selectedVersionData[index].version
        //     this.getProductTypeList()
        //   }
        // }
        // 详情的name是数组
        if (formData.freeConfigList && formData.freeConfigList.length > 0) {
          formData.freeConfigList.map(e => {
            e.name = e.name[0]
          })
        }
        if (formData.vasLabel) {
          this.vasLabelId = formData.vasLabel.labelId
          this.currentId = this.vasLabelId
          this.dateRange = [
            formData.vasLabel.startTime,
            formData.vasLabel.endTime
          ]
        }
        this.formData = formData
      }
    },
    canSubmit () {
      const flag = { submit: true }
      if (!this.formData.name) {
        this.$notify.error({
          title: '错误',
          message: '应用标题必填'
        })
        return false
      }
      if (!this.formData.vasChannelList) {
        this.$notify.error({
          title: '错误',
          message: '发布渠道必选'
        })
        return false
      }
      if (!this.formData.remark) {
        this.$notify.error({
          title: '错误',
          message: '应用标题备注不为空'
        })
        return false
      }
      if (!this.formData.iconUrl) {
        this.$notify.error({
          title: '错误',
          message: '请上传图标'
        })
        return false
      }
      if (!this.formData.summaryContent) {
        this.$notify.error({
          title: '错误',
          message: '应用介绍必填'
        })
        return false
      }

      if (
        !this.formData.vasTypeList ||
        this.formData.vasTypeList.length === 0
      ) {
        this.$notify.error({
          title: '错误',
          message: '所属分类至少选一个'
        })
        return false
      }
      if (!this.formData.name) {
        this.$notify.error({
          title: '错误',
          message: '应用标题必填'
        })
        return false
      }
      if (!this.formData.priceUnit) {
        this.$notify.error({
          title: '错误',
          message: '价格单位必填'
        })
        return false
      }
      // 选择版本默认
      if (!this.selectedVersionData || this.selectedVersionData.length === 0) {
        this.$notify.error({
          title: '错误',
          message: '版本选项不能为空'
        })
        return false
      }
      const result = this.selectedVersionData.some((item, index) => {
        return item.isDefault === true
      })
      if (!result) {
        this.$notify.error({
          title: '错误',
          message: '版本默认选项必选'
        })
        return false
      }
      // if (this.formData.successedType === 0 && !this.formData.successContent) {
      //   this.$notify.error({
      //     title: '错误',
      //     message: '开通弹窗文案不为空'
      //   })
      //   return false
      // }
      if (!this.formData.onlineServiceChannelId) {
        this.$notify.error({
          title: '错误',
          message: '客服Channel ID必选'
        })
        return false
      }

      if (this.formData.hasFreeOption === true && !this.formData.freeContent) {
        this.$notify.error({
          title: '错误',
          message: '试用开通内容必填'
        })
        return false
      }
      if (
        this.formData.hasFreeOption === true &&
        this.formData.freeConfigList &&
        this.formData.freeConfigList.length > 0
      ) {
        const val = this.formData.freeConfigList.every((item, index) => {
          return item.count
        })
        if (!val) {
          this.$notify.error({
            title: '错误',
            message: '试用内容不可为空'
          })
          return false
        }
      }
      // if (
      //   this.formData.vasChannelList.indexOf(1) !== -1 &&
      //   (!this.formData.imgUrlList || this.formData.imgUrlList.length === 0)
      // ) {
      //   this.$notify.error({
      //     title: '错误',
      //     message: '请上传云平台详情图'
      //   })
      //   return false
      // }
      if (
        this.formData.vasChannelList.indexOf(2) !== -1 &&
        (!this.formData.storeImgUrlList ||
          this.formData.storeImgUrlList.length === 0)
      ) {
        this.$notify.error({
          title: '错误',
          message: '请上传我的店铺详情图'
        })
        return false
      }
      if (
        this.formData.vasChannelList.indexOf(2) !== -1 &&
        !this.formData.storeIconUrl
      ) {
        this.$notify.error({
          title: '错误',
          message: '请上传我的店铺图标'
        })
        return false
      }
      const temp = this.formData.vasCommentList.filter(item => {
        return (
          item.content != null ||
          item.storeName != null ||
          item.storeAddress != null
        )
      })
      if (temp.length === 0) {
        this.$notify.error({
          title: '错误',
          message: '用户评价必填'
        })
        return false
      }
      return flag.submit
    },
    async submit (type) {
      this.formData.versionList = this.selectedVersionData
      this.formData.vasDetailHeight = this.formData.vasDetailHeight || 2500 // 详情图默认高度2500
      if (this.state === 'created') {
        this.formData.enable = true
        if (!this.canSubmit()) {
          return
        }
        if (type === '0') {
          const res = await saveApplication(this.formData)
          if (res.status === 'success') {
            this.$router.push('/application-config')
            this.$message.success('保存成功')
          } else {
            this.$message.error(res.messages || 'error')
          }
        }
      } else if (this.state === 'edit') {
        this.formData.uid = this.id
        if (type === '0') {
          this.formData.enable = true
          if (!this.canSubmit()) {
            return
          }

          const res = await saveApplication(this.formData)
          if (res.status === 'success') {
            this.$router.push('/application-config')
            this.$message.success('发布成功')
          } else {
            this.$message.error(res.messages || 'error')
          }
        } else if (type === 'save') {
          this.formData.enable = false
          const res = await saveApplication(this.formData)
          if (res.status === 'success') {
            this.$router.push('/application-config')
            this.$message.success('保存成功')
          } else {
            this.$message.error(res.messages || 'error')
          }
        } else if (type === 'copy') {
          this.formData.enable = false
          this.formData.uid = ''
          const res = await saveApplication(this.formData)
          if (res.status === 'success') {
            this.$router.push('/application-config')
            this.$message.success('复制成功')
          } else {
            this.$message.error(res.messages || 'error')
          }
        } else if (type === '-1') {
          this.$confirm('删除后无法复原', '确认删除当前应用', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(async () => {
              const res = await changeApplyhub({ uid: this.id, status: -1 })
              if (res.status === 'success') {
                this.$router.push('/application-config')
                this.$message.success('删除成功')
              } else {
                this.$message.error(res.messages || 'error')
              }
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              })
            })
        }
      }
    },
    backPage () {
      this.$router.go(-1)
    },
    // 获取客户channel ID选项
    async getChannelIDList () {
      const temp = {
        search: ''
      }
      this.channelIDList = await getCustomerChannelList(temp)
    },
    // 新增用户评价
    addUserContent () {
      if (this.formData.vasCommentList.length > 49) {
        this.$notify.error({
          type: 'error',
          message: '用户评价最多可添加50条'
        })
        return
      }
      const temp = {
        content: null,
        storeName: null,
        storeAddress: null
      }
      this.formData.vasCommentList.push(temp)
    },
    // 删除用户评价
    deleteUserContent (idx) {
      this.formData.vasCommentList.splice(idx, 1)
    },
    // 开通/试用成功跳转选择
    selectHttpOrOnlineService () {
      if (this.formData.openOnlineServiceAfterPaid) {
        this.formData.afterPaidChannelId = this.formData.onlineServiceChannelId
      } else {
        this.formData.afterPaidChannelId = null
      }
    }
  }
}
</script>
<style>
.label-height .el-form-item__label {
  line-height: 20px;
}
</style>
<style lang="less">
.show_name {
  .el-dialog__header {
    padding-bottom: 15px;
    border-bottom: 1px solid var(--form-line);
  }
}
.userContentTable {
  border: 1px solid rgb(219, 217, 217);
  width: 850px;
  th {
    color: rgb(180, 178, 178);
    font-size: 14px;
    font-weight: 200;
  }
  .storeNameInput {
    margin-top: 15px;
  }
  .deleteUserContent {
    width: 35px;
    height: 35px;
    color: red;
    font-size: 35px;
    padding-left: 10px;
  }
}

.el-message-box__btns {
  display: flex;
  justify-content: flex-end;
}

.el-radio-button__inner,
.el-checkbox-button__inner {
  font-weight: 300;
}

.el-radio-button__orig-radio:checked + .el-radio-button__inner,
.el-radio__input.is-checked .el-radio__inner,
.el-checkbox-button.is-checked .el-checkbox-button__inner,
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: #2878ff;
}

.el-checkbox-button.is-checked .el-checkbox-button__inner {
  border: none !important;
}

.el-button--small {
  font-size: 14px;
}

.headline > .el-button {
  height: 40px !important;
}

.el-radio__input.is-checked + .el-radio__label {
  color: #2878ff;
}

.el-input-group__append,
.el-input-group__prepend {
  background: none;
}

.el-input-group > .el-input__inner {
  border-right: 0;
}

.el-dialog__body {
  padding-bottom: 0;
}

.chooseTagName {
  margin-top: 4px;
  padding: 0 8px;
  height: 32px;
  display: inline-block;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #404757c7;
  background: #dde4f04d;
  border-radius: 4px;
  line-height: 32px;
  margin-right: 4px;
}

.chooseTagName:last-of-type {
  margin-right: 10px;
}

.el-button {
  height: 32px !important;
  font-weight: 200;
  align-items: center;
  justify-content: center;
}

.el-input {
  height: 32px;
}

.el-form-item {
  margin-bottom: 10px;
  align-items: flex-start;
}

.el-checkbox-button__inner {
  border: 1px solid #dcdfe6 !important;
  border-radius: 4px !important;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.targetPopulation i {
  font-size: 28px;
}

.targetPopulation .el-radio-button__inner > div {
  display: flex;
  align-items: center;
}

.el-range-separator {
  height: auto !important;
}

.select-trigger {
  width: 280px;
}

.el-input__inner {
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-radio-button__inner {
  height: 32px;
  display: flex;
  align-items: center;
}
.form-itemTheme {
  .el-form-item__label {
    display: flex;
    align-items: center;
  }
}
.form-box {
  .title-col {
    color: #000000;
    font-size: 14px;
    width: 100%;
    height: 36px;
    line-height: 36px;
    background: #f3f3f4;
    border-radius: 2px;
    padding-left: 13px;
    margin-bottom: 20px;
  }

  .h64 {
    .el-input__inner {
      height: 64px;
    }
  }

  .look-location {
    font-size: 14px;
    color: #255aff;
    margin-left: 10px;
    vertical-align: top;
    cursor: pointer;
  }

  .tips {
    color: #b9bcc1;
    font-size: 12px;
    &-look-location {
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      position: absolute;
      top: 80px;
      left: 110px;
      cursor: pointer;
      color: #2878ff;
    }
  }

  .el-checkbox-group {
    color: #5f6572;

    .el-checkbox-button.is-checked .el-checkbox-button__inner {
      color: #2878ff;
      background: #e9f1ff;
      border: none;
      box-shadow: none !important;
    }
  }

  .select-text {
    margin-right: 35px;
  }

  .el-textarea__inner {
    border-radius: 0;
    border-top-right-radius: 2px;
    border-top-left-radius: 2px;
  }

  .tab-text {
    border: 1px solid #e2e3e5;
    border-top: 0;
    border-bottom-right-radius: 2px;
    border-bottom-left-radius: 2px;
    width: 278px;
    height: 32px;
    line-height: 32px;
    cursor: pointer;

    span {
      color: #9ca0a8;
      font-size: 12px;
      width: 87px;
      text-align: center;
      // padding: 0px 12px;
      // height: 32px;
      // line-height: 32px;
      display: inline-block;
      border-right: 1px solid #e2e3e5;

      &:last-child {
        border-right: none;
      }
    }
  }

  .try-input {
    width: 120px;
  }

  .el-input-group__append {
    padding: 0 8px;
  }
}

.tab-card {
  height: 32px;
  line-height: 32px;
  color: #111a2e;
  font-size: 14px;
  cursor: pointer;
  display: inline-block;
  margin-right: 4px;
  padding: 0 12px 0 8px;
  background: #f3f3f4;
  border-radius: 2px;
}

.box-table {
  width: 861px;
  height: 358px;
  border-top: 1px solid #e2e3e5;
  box-sizing: border-box;
  border-radius: 2px;
  margin-top: 22px;
  overflow-y: auto;
  overflow-x: hidden;

  .el-checkbox {
    border-right: 1px solid #e2e3e5;
    border-bottom: 1px solid #e2e3e5;
    border-left: 1px solid #e2e3e5;
    // height: 60px;
    // line-height: 58px;
    height: 50px;
    padding-left: 17px;
    padding-right: 12px;
    // width: 430px;
    width: 423px;
    box-sizing: border-box;
    display: flex;
    // align-items: center;
    float: left;
    margin-right: 0;
    padding-top: 8px;

    .el-checkbox__label {
      flex: 1;
    }
  }

  .name {
    width: 130px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    // height: 60px;
    // line-height: 60px;
  }

  .version {
    float: right;
  }
}
</style>
<style lang="less" scoped>
.off-button {
  background: var(--warning);
  color: #fff;
}

.dialog-footer,
.footer > div {
  display: flex;
  justify-content: flex-end;
}

.pagination {
  width: 100%;
  margin-top: 20px;
}

.el-form-item__content p {
  margin: 0;
}

.panel {
  .back {
    font-size: 16px;
    color: var(--main-text);
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 18px;
    height: 28px;
    border-right: 1px solid var(--form-line);
    width: 90px;

    i {
      font-size: 28px;
    }
  }
}

.panel:last-child {
  margin-bottom: 90px;
}

.footer {
  position: fixed;
  bottom: 0px;
  left: 96px;
  background-color: var(--white);
  border-radius: 1px;
  padding: 23px 53px;
  width: calc(100% - 200px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  z-index: 100;
  box-shadow: 0 -2px 8px 0 #eeeeee;

  &__button {
    width: 96px;
    height: 36px;
  }

  .set_template {
    display: flex;
    justify-content: center;
    align-items: center;

    &__checkbox {
      margin-right: 10px;
    }

    &__input {
      width: 280px;
    }
  }
}

.edit-panel {
  background-color: var(--white);
  border-radius: 1px;
  padding: 20px 30px;

  .el-checkbox-button {
    margin-right: 8px;
  }

  .title {
    font-size: 20px;
    color: var(--main-text);
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .el-checkbox {
      margin-right: 10px;
    }
  }
}

.show_list {
  padding: 0 20px;
  margin-left: 5px;
}

.tag_edit .el-form-item__content > div {
  display: flex;
  align-items: center;
}

.draft-box {
  padding: 10px 13px;

  &__cell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    cursor: pointer;

    span {
      font-size: 16px;
      color: var(--main-text);
    }

    i {
      font-size: 16px;
      color: #91959f;
    }
  }
}

.excel {
  display: flex;
  align-items: center;
  height: 100%;
}
.flex {
  display: flex;
  align-items: center;
}
</style>
